import { ArrowDown } from "lucide-react";

export const SortArrowIcon = ({ active, ascending }) => {
    if (!active) return null;

    return (
        <ArrowDown
            size={14}
            style={{ transform: ascending ? "rotate(180deg)" : "rotate(0deg)", transition: "transform 0.15s" }}
            color="var(--cm-p-accent)"
        />
    );
};
